import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActiveUsers = ({ activeUsers, currentUser }) => {
  const getPresenceColor = (status) => {
    switch (status) {
      case 'active': return 'bg-success';
      case 'away': return 'bg-warning';
      case 'busy': return 'bg-error';
      default: return 'bg-muted';
    }
  };

  const getPresenceText = (status) => {
    switch (status) {
      case 'active': return 'Active';
      case 'away': return 'Away';
      case 'busy': return 'Busy';
      default: return 'Offline';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-lg font-semibold text-foreground flex items-center gap-2 mb-4">
        <Icon name="Users" size={20} />
        Active Users ({activeUsers?.length})
      </h2>
      <div className="space-y-3">
        {activeUsers?.map((user) => (
          <div key={user?.id} className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-3">
              <div className="relative">
                <Image
                  src={user?.avatar}
                  alt={user?.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className={`absolute -bottom-1 -right-1 w-4 h-4 ${getPresenceColor(user?.presence)} rounded-full border-2 border-card`} />
              </div>
              
              <div>
                <div className="flex items-center gap-2">
                  <p className="font-medium text-foreground">{user?.name}</p>
                  {user?.id === currentUser?.id && (
                    <span className="px-2 py-0.5 text-xs bg-primary text-primary-foreground rounded-full">
                      You
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground">{user?.role}</p>
              </div>
            </div>

            <div className="text-right">
              <p className={`text-sm font-medium ${
                user?.presence === 'active' ? 'text-success' : 
                user?.presence === 'away' ? 'text-warning' : 
                user?.presence === 'busy' ? 'text-error' : 'text-muted-foreground'
              }`}>
                {getPresenceText(user?.presence)}
              </p>
              <p className="text-xs text-muted-foreground">
                {user?.lastActivity}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Current Activity */}
      <div className="mt-4 pt-4 border-t border-border">
        <h3 className="text-sm font-medium text-foreground mb-2">Current Activity</h3>
        <div className="space-y-2">
          {activeUsers?.filter(user => user?.currentActivity)?.map((user) => (
            <div key={`activity-${user?.id}`} className="flex items-center gap-2 text-sm">
              <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
              <span className="text-muted-foreground">
                <span className="font-medium text-foreground">{user?.name}</span> {user?.currentActivity}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActiveUsers;